module.exports = __webpack_public_path__ + "static/media/schedule.d6ea7846.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallet/schedule.png
// module id = 2072
// module chunks = 6